import { useEffect, useState, useRef } from "react";

import { useAuth } from "../contexts/auth.context";

import ProfileImage from "../assets/png/profile-pics.png";
import { useProject } from "../contexts/new-project.context";
import { httpRequest } from "../utils/http.util";
import { useError } from "../contexts/error.context";
import { GoSignOut } from "react-icons/go";

export default function ProfileMenu() {
  const { user, logOut } = useAuth();
  const { setUserInfo } = useProject();
  const { handleAPIError } = useError(); 
  const menuRef = useRef(null);

  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [userDetails, setUserDetails] = useState({});

  const toggleMenu = () => {
    setIsMenuOpen((prev) => !prev);
  };

  useEffect(() => {
    const fetchUserDetails = async () => {
      try {
        const response = await httpRequest({
          method: "GET",
          url: `/user/`,
          isAuthRequired: true,
        });
        setUserDetails(response.data);
        setUserInfo(response.data);
      } catch (error) {
        handleAPIError(error);
      }
    };

    if (user) {
      fetchUserDetails();
    }
  }, [user,handleAPIError, setUserInfo]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsMenuOpen(false);
      }
    };

    if (isMenuOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isMenuOpen]);

  return (
    <div className="relative inline-block">
      <div
        onClick={toggleMenu}
        className="w-11 h-11 cursor-pointer rounded-full outline outline-2 outline-[#E7EBF1] border-2 border-transparent"
      >
        <img
          src={userDetails?.photo_url || ProfileImage}
          alt="User profile menu"
          className="w-full h-full object-contain rounded-full"
          referrerPolicy="no-referrer"
          width={44}
          height={44}
          loading="lazy"
        />
      </div>

      {isMenuOpen && (
        <div ref={menuRef} className="min-w-56 mt-2 origin-top-right absolute right-0 z-50 border rounded shadow bg-[#F7F8FA] border-[#D2D9E5]">
          <div className="p-3">
            <p className="text-[#06060699]">{user.email}</p>
          </div>

          <hr className="h-1" />

          <div
            className="p-3 cursor-pointer flex items-center gap-x-2 bg-[#F7F8FA] hover:bg-opacity-70"
            onClick={logOut}
          >
            <GoSignOut /> <p>Sign Out</p>
          </div>
        </div>
      )}
    </div>
  );
}
